import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import BigImage from '../../components/BigImage'
import Paginate from '../../components/Paginate'
import Prompts from '../../components/Prompts'
import SectionHeader from '../../components/SectionHeader'
import Paragraph from '../../components/Paragraph'
import patient from '../../stores/patient'
import MotivationToggles from './MotivationToggles'
import PostStrengthsPrompts2 from './PostStrengthsPrompts2'
import StrengthToggles from './StrengthToggles'

@observer
export default class GoalSession2 extends Component {
  render() {
    return (
      <Fragment>
        <Prompts>
          <Prompts.Q str="prose.itsGreatToSeeYou" />
          <Prompts.R str="prose.itSoundsLike" />
          <Prompts.S>
            <Paragraph str="prose.knowYouALittleBetter" />
            <Paragraph str="prose.lastTimeWeMet" />
          </Prompts.S>
          <Prompts.Q str="prose.tellMeHowItsGone" />
          <Prompts.R str="prose.youHave" />
        </Prompts>
        {/* MOTIVATIONS */}
        <SectionHeader color="red" icon="fas fa-handshake" str="titles.motivations" />
        <BigImage src="/images/family-hugging.jpg" />
        <Prompts>
          {patient.fields.lowVision==="YES"?<Prompts.Q str="prose.ifItsOkayLowVision" />:<Prompts.Q str="prose.ifItsOkay" />}
        </Prompts>
        <MotivationToggles />
        <Prompts>
          <Prompts.Q str="prose.itSoundsLikeBlank" />
          <Prompts.R str="prose.imHearingThat" />
        </Prompts>
        {/* STRENGTHS */}
        <SectionHeader color="red" icon="fas fa-heart" str="titles.strengths" />
        <BigImage src="/images/roadmap.jpg" />
        <Prompts>
          {patient.fields.lowVision==="YES"?<Prompts.Q str="prose.weHaveFoundThatLowVision" />:<Prompts.Q str="prose.weHaveFoundThat" />}
        </Prompts>
        <StrengthToggles />
        <PostStrengthsPrompts2 />
        {/* PAGINATE */}
        <Paginate>
          <Paginate.Button next
            color="orange"
            str="titles.use"
            to={`/use/second/${patient.fields._id}`}
          />
        </Paginate>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Goal/GoalSession2.js